module.exports = __webpack_public_path__ + "static/media/lock.5eebaa3c.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/lock.svg
// module id = 232
// module chunks = 1